module.exports = __webpack_public_path__ + "img/arrow-long-left.c2b0ce05.svg";